import {RouteRecordRaw} from "vue-router"
import AdminContainerView from "@/views/Admin/AdminContainerView.vue";
import LoginView from "@/views/LoginView.vue";

const AdminDashboardView = () => import("@/views/Admin/DashboardView.vue")
const AdminStudentView = () => import("@/views/Admin/Student/StudentView.vue")
const AdminStudentListView = () => import("@/views/Admin/Student/ListView.vue")
const AdminStudentItemView = () => import("@/views/Admin/Student/ItemView.vue")
const AdminTeacherView = () => import("@/views/Admin/Teacher/TeacherView.vue")
const AdminTeacherListView = () => import("@/views/Admin/Teacher/ListView.vue")
const AdminTeacherItemView = () => import("@/views/Admin/Teacher/ItemView.vue")
const AdminInsuranceView = () => import("@/views/Admin/Insurance/InsuranceView.vue")
const AdminInsuranceListView = () => import("@/views/Admin/Insurance/ListView.vue")
const AdminInsuranceItemView = () => import("@/views/Admin/Insurance/ItemView.vue")
const AdminMedicalCertificateView = () => import("@/views/Admin/MedicalCertificate/MedicalCertificateView.vue")
const AdminMedicalCertificateListView = () => import("@/views/Admin/MedicalCertificate/ListView.vue")
const AdminMedicalCertificateItemView = () => import("@/views/Admin/MedicalCertificate/ItemView.vue")
const AdminCardView = () => import("@/views/Admin/Card/CardView.vue")
const AdminCardListView = () => import("@/views/Admin/Card/ListView.vue")
const AdminCardItemView = () => import("@/views/Admin/Card/ItemView.vue")
const AdminCardTypeView = () => import("@/views/Admin/CardType/CardTypeView.vue")
const AdminCardTypeListView = () => import("@/views/Admin/CardType/ListView.vue")
const AdminCardTypeItemView = () => import("@/views/Admin/CardType/ItemView.vue")
const AdminCourseView = () => import("@/views/Admin/Course/CourseView.vue")
const AdminCourseListView = () => import("@/views/Admin/Course/ListView.vue")
const AdminCourseItemView = () => import("@/views/Admin/Course/ItemView.vue")
const AdminLessonView = () => import("@/views/Admin/Lesson/LessonView.vue")
const AdminLessonListView = () => import("@/views/Admin/Lesson/ListView.vue")
const AdminLessonItemView = () => import("@/views/Admin/Lesson/ItemView.vue")
const AdminLessonScheduleView = () => import("@/views/Admin/Lesson/ScheduleView.vue")
const AdminGalaView = () => import("@/views/Admin/Gala/GalaView.vue")
const AdminGalaListView = () => import("@/views/Admin/Gala/ListView.vue")
const AdminGalaItemView = () => import("@/views/Admin/Gala/ItemView.vue")
const AdminWorkshopView = () => import("@/views/Admin/Workshop/WorkshopView.vue")
const AdminWorkshopListView = () => import("@/views/Admin/Workshop/ListView.vue")
const AdminWorkshopItemView = () => import("@/views/Admin/Workshop/ItemView.vue")
const AdminWorkshopDayView = () => import("@/views/Admin/WorkshopDay/WorkshopDayView.vue")
const AdminWorkshopDayListView = () => import("@/views/Admin/WorkshopDay/ListView.vue")
const AdminWorkshopDayItemView = () => import("@/views/Admin/WorkshopDay/ItemView.vue")
const AdminHolidaysView = () => import("@/views/Admin/Holidays/HolidaysView.vue")
const AdminHolidaysListView = () => import("@/views/Admin/Holidays/ListView.vue")
const AdminHolidaysItemView = () => import("@/views/Admin/Holidays/ItemView.vue")
const AdminContactPersonView = () => import("@/views/Admin/ContactPerson/ContactPersonView.vue")
const AdminContactPersonListView = () => import("@/views/Admin/ContactPerson/ListView.vue")
const AdminContactPersonItemView = () => import("@/views/Admin/ContactPerson/ItemView.vue")
const AdminAdminView = () => import("@/views/Admin/Admin/AdminView.vue")
const AdminAdminListView = () => import("@/views/Admin/Admin/ListView.vue")
const AdminAdminItemView = () => import("@/views/Admin/Admin/ItemView.vue")
const AdminPaymentView = () => import("@/views/Admin/Payment/PaymentView.vue")
const AdminPaymentListView = () => import("@/views/Admin/Payment/ListView.vue")
const AdminPaymentItemView = () => import("@/views/Admin/Payment/ItemView.vue")
const AdminRegistrationFeeCreditListView = () => import("@/views/Admin/RegistrationFeeCredit/ListView.vue")
const AdminClothingSizeView = () => import("@/views/Admin/ClothingSize/ClothingSizeView.vue")
const AdminClothingSizeListView = () => import("@/views/Admin/ClothingSize/ListView.vue")
const AdminClothingSizeItemView = () => import("@/views/Admin/ClothingSize/ItemView.vue")

const AdminSettingsView = () => import("@/views/Admin/SettingsView.vue")
const AdminReportView = () => import("@/views/Admin/Report/ReportView.vue")
const AdminReportTeacherHoursView = () => import("@/views/Admin/Report/TeacherHoursReportView.vue")
// const AdminReportCourseRegistrationsView = () => import("@/views/Admin/Report/CourseRegistrationsReportView.vue")
const AdminReportStudentCoursesView = () => import("@/views/Admin/Report/StudentCoursesReportView.vue")
const AdminReportGalaRegistrationsView = () => import("@/views/Admin/Report/GalaRegistrationsReportView.vue")
const AdminReportTeacherCoursesView = () => import("@/views/Admin/Report/TeacherCoursesReportView.vue")
const AdminReportInsuranceView = () => import("@/views/Admin/Report/InsuranceReportView.vue")

export const routes: Array<RouteRecordRaw> = [
    {
        path: '/admin/login',
        name: 'admin_login',
        component: LoginView,
    },
    {
        path: '/admin',
        component: AdminContainerView,
        children: [
            {
                path: 'dashboard',
                name: 'admin_dashboard',
                component: AdminDashboardView,
            },
            {
                path: 'settings',
                name: 'admin_settings',
                component: AdminSettingsView,
            },
            {
                path: 'students',
                component: AdminStudentView,
                children: [
                    {
                        path: '',
                        name: 'admin_student_list',
                        component: AdminStudentListView
                    },
                    {
                        path: ':id',
                        name: 'admin_student_item',
                        component: AdminStudentItemView
                    }
                ]
            },
            {
                path: 'teachers',
                component: AdminTeacherView,
                children: [
                    {
                        path: '',
                        name: 'admin_teacher_list',
                        component: AdminTeacherListView
                    },
                    {
                        path: ':id',
                        name: 'admin_teacher_item',
                        component: AdminTeacherItemView
                    }
                ]
            },
            {
                path: 'insurances',
                component: AdminInsuranceView,
                children: [
                    {
                        path: '',
                        name: 'admin_insurance_list',
                        component: AdminInsuranceListView
                    },
                    {
                        path: ':id',
                        name: 'admin_insurance_item',
                        component: AdminInsuranceItemView
                    }
                ]
            },
            {
                path: 'medical_certificates',
                component: AdminMedicalCertificateView,
                children: [
                    {
                        path: '',
                        name: 'admin_medical_certificate_list',
                        component: AdminMedicalCertificateListView
                    },
                    {
                        path: ':id',
                        name: 'admin_medical_certificate_item',
                        component: AdminMedicalCertificateItemView
                    }
                ]
            },
            {
                path: 'cards',
                component: AdminCardView,
                children: [
                    {
                        path: '',
                        name: 'admin_card_list',
                        component: AdminCardListView
                    },
                    {
                        path: ':id',
                        name: 'admin_card_item',
                        component: AdminCardItemView
                    }
                ]
            },
            {
                path: 'card_types',
                component: AdminCardTypeView,
                children: [
                    {
                        path: '',
                        name: 'admin_card_type_list',
                        component: AdminCardTypeListView
                    },
                    {
                        path: ':id',
                        name: 'admin_card_type_item',
                        component: AdminCardTypeItemView
                    }
                ]
            },
            {
                path: 'courses',
                component: AdminCourseView,
                children: [
                    {
                        path: '',
                        name: 'admin_course_list',
                        component: AdminCourseListView
                    },
                    {
                        path: ':id',
                        name: 'admin_course_item',
                        component: AdminCourseItemView
                    }
                ]
            },
            {
                path: 'lessons',
                component: AdminLessonView,
                children: [
                    {
                        path: 'schedule',
                        name: 'admin_lesson_schedule',
                        component: AdminLessonScheduleView
                    },
                    {
                        path: '',
                        name: 'admin_lesson_list',
                        component: AdminLessonListView
                    },
                    {
                        path: ':id',
                        name: 'admin_lesson_item',
                        component: AdminLessonItemView
                    }
                ]
            },
            {
                path: 'galas',
                component: AdminGalaView,
                children: [
                    {
                        path: '',
                        name: 'admin_gala_list',
                        component: AdminGalaListView
                    },
                    {
                        path: ':id',
                        name: 'admin_gala_item',
                        component: AdminGalaItemView
                    }
                ]
            },
            {
                path: 'workshops',
                component: AdminWorkshopView,
                children: [
                    {
                        path: '',
                        name: 'admin_workshop_list',
                        component: AdminWorkshopListView
                    },
                    {
                        path: ':id',
                        name: 'admin_workshop_item',
                        component: AdminWorkshopItemView
                    }
                ]
            },
            {
                path: 'workshop_days',
                component: AdminWorkshopDayView,
                children: [
                    {
                        path: '',
                        name: 'admin_workshop_day_list',
                        component: AdminWorkshopDayListView
                    },
                    {
                        path: ':id',
                        name: 'admin_workshop_day_item',
                        component: AdminWorkshopDayItemView
                    }
                ]
            },
            {
                path: 'holidays',
                component: AdminHolidaysView,
                children: [
                    {
                        path: '',
                        name: 'admin_holidays_list',
                        component: AdminHolidaysListView
                    },
                    {
                        path: ':id',
                        name: 'admin_holidays_item',
                        component: AdminHolidaysItemView
                    }
                ]
            },
            {
                path: 'contact_people',
                component: AdminContactPersonView,
                children: [
                    {
                        path: '',
                        name: 'admin_contact_person_list',
                        component: AdminContactPersonListView
                    },
                    {
                        path: ':id',
                        name: 'admin_contact_person_item',
                        component: AdminContactPersonItemView
                    }
                ]
            },
            {
                path: 'admins',
                component: AdminAdminView,
                children: [
                    {
                        path: '',
                        name: 'admin_admin_list',
                        component: AdminAdminListView
                    },
                    {
                        path: ':id',
                        name: 'admin_admin_item',
                        component: AdminAdminItemView
                    }
                ]
            },
            {
                path: 'payments',
                component: AdminPaymentView,
                children: [
                    {
                        path: '',
                        name: 'admin_payment_list',
                        component: AdminPaymentListView
                    },
                    {
                        path: ':id',
                        name: 'admin_payment_item',
                        component: AdminPaymentItemView
                    }
                ]
            },
            {
                path: 'registration-fee-credits',
                name: 'admin_registration_fee_credit_list',
                component: AdminRegistrationFeeCreditListView
            },
            {
                path: 'clothing_sizes',
                component: AdminClothingSizeView,
                children: [
                    {
                        path: '',
                        name: 'admin_clothing_size_list',
                        component: AdminClothingSizeListView
                    },
                    {
                        path: ':id',
                        name: 'admin_clothing_size_item',
                        component: AdminClothingSizeItemView
                    }
                ]
            },
            {
                path: 'reports',
                component: AdminReportView,
                children: [
                    {
                        path: '',
                        redirect: {name: 'admin_report_teacher_hours'}
                    },
                    {
                        path: 'teacher-hours',
                        name: 'admin_report_teacher_hours',
                        component: AdminReportTeacherHoursView
                    },
                    {
                        path: 'student-courses',
                        name: 'admin_report_student_courses',
                        component: AdminReportStudentCoursesView
                    },
                    {
                        path: 'gala-registrations',
                        name: 'admin_report_gala_registrations',
                        component: AdminReportGalaRegistrationsView
                    },
                    {
                        path: 'teacher-courses',
                        name: 'admin_report_teacher_courses',
                        component: AdminReportTeacherCoursesView
                    },
                    {
                        path: 'insurance',
                        name: 'admin_report_insurance',
                        component: AdminReportInsuranceView
                    },
                    // {
                    //     path: 'course-registrations',
                    //     name: 'admin_report_course_registrations',
                    //     component: AdminReportCourseRegistrationsView
                    // }
                ]
            },
        ]
    }
]
